var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"stepper-button",attrs:{"id":("stepper-button--" + _vm.type)},on:{"click":_vm.clickHandler}},[_c('Icon',{attrs:{"type":_vm.type,"color":_vm.color}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }